import React, { createContext, useContext, useState } from "react";

const SqlResultsContext = createContext();

export const useSqlResults = () => {
  const context = useContext(SqlResultsContext);
  if (!context) {
    throw new Error("useSqlResults must be used within SqlResultsProvider");
  }
  return context;
};

export const SqlResultsProvider = ({ children }) => {
  const [results, setResults] = useState(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const setSqlResults = (data, autoOpen = false) => {
    // Handle null/undefined data by clearing results
    if (!data) {
      clearResults();
      return;
    }
    
    // Add timestamp if not already present
    const resultsWithTimestamp = {
      ...data,
      timestamp: data.timestamp || Date.now(),
    };
    setResults(resultsWithTimestamp);
    // Only auto-open panel if explicitly requested (e.g., from SQL editor)
    // Open for both success (with data) and error cases
    if (autoOpen && data) {
      if (data.success && data.data && data.data.length > 0) {
        setIsPanelOpen(true);
      } else if (!data.success && data.error) {
        // Also open on error to show error message
        setIsPanelOpen(true);
      }
    }
  };

  const clearResults = () => {
    setResults(null);
    setIsPanelOpen(false);
  };

  const togglePanel = () => {
    setIsPanelOpen((prev) => !prev);
  };

  return (
    <SqlResultsContext.Provider
      value={{
        results,
        setSqlResults,
        clearResults,
        isPanelOpen,
        setIsPanelOpen,
        togglePanel,
      }}
    >
      {children}
    </SqlResultsContext.Provider>
  );
};

